import { Radio as RadioIcon } from "lucide-react";

/**
 * Small live indicator that shows the on-air state of the persistent radio
 * player. Pulses when a track is actively playing.
 */
export default function OnAirIndicator({ live }) {
  return (
    <div className="hidden lg:flex items-center gap-2 border border-[#2A2A2A] px-3 h-9 bg-black/60">
      <span className="relative flex h-2 w-2">
        <span
          className={`absolute inline-flex h-full w-full rounded-full bg-[#FF4500] ${
            live ? "animate-ping opacity-75" : "opacity-0"
          }`}
        />
        <span
          className={`relative inline-flex h-2 w-2 rounded-full ${
            live ? "bg-[#FF4500]" : "bg-gray-600"
          }`}
        />
      </span>
      <RadioIcon className="h-3.5 w-3.5 text-gray-400" />
      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gray-400">
        {live ? "On Air" : "Off Air"}
      </span>
    </div>
  );
}
